<template>
	<v-layout row wrap>
		<v-flex xs12>
			<v-card class="pa-5">
				<h5 class="mb-4 headline">Referrals</h5>
				<v-layout class="mb-5">
					<v-flex xs6 class="dashed">
						<v-layout>
							<v-flex class="allCenteredChild no-flex-grow">
								<h5 class="pr-4 ma-0 subheading blue--text">
									Send Invite Link
								</h5>
							</v-flex>
							<v-flex xs12 md6>
								<v-text-field
									label="Enter Phone no."
									v-model="phoneNo"
									:color="themeInputColor"
									@keyup.enter="sendReferralInvite"
								></v-text-field>
							</v-flex>
							<v-flex class="mx-3 allCenteredChild">
								<v-btn
									small
									fab
									:color="themeInputColor"
									class="white--text"
									@click="sendReferralInvite"
									:loading="sendInviteLoading"
								>
									<v-icon>send</v-icon>
								</v-btn>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout class="mb-3">
					<h4 class="title grey--text ma-0">Successfull Referrals</h4>
					<v-icon :color="themeInputColor" class="grey--text px-2"
						>check_circle</v-icon
					>
				</v-layout>
				<advance-list-view
					:allProps="allProps"
					:allData="transactionHistory"
					uniqueKey="handle"
					:themeInputColor="themeInputColor"
					:isTableInteractive="false"
					:nextOffset="!transactionHistoryOffset ? 'end' : ''"
					@LOAD_MORE_ROWS="getReferralsHistory('end')"
					:loadMoreLoading="getReferralHistoryLoading"
				/>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapState } from "vuex";

import AdvanceListView from "@/components/Advance-list-view.vue";
import { GET_REFERRALS, SEND_INVITE, SHOW_ALERT } from "@/store/action-types";
import { themeInputColor } from "@/utils";
export default {
	name: "Referral",
	data() {
		return {
			themeInputColor,
			phoneNo: null,
			sendInviteLoading: false,
			getReferralHistoryLoading: false,
			allProps: [
				{ text: "Pic", key: "pic" },
				{ text: "Name", key: "name" },
				{ text: "Handle", key: "handle" },
				{ text: "Language", key: "language" }
			]
		};
	},
	components: {
		"advance-list-view": AdvanceListView
	},
	mounted() {
		this.getReferralsHistory("start");
		// console.log("transactionHistory: ", this.transactionHistory);
	},
	computed: {
		...mapState({
			retailerId: state => state.auth.USERID,
			transactionHistory: state =>
				state.retailReferral.retailReferralHistory,
			transactionHistoryOffset: state =>
				state.retailReferral.retailReferralHistoryOffset
		})
	},
	methods: {
		getReferralsHistory(type) {
			this.$store.dispatch(GET_REFERRALS.dispatch, {
				userId: this.retailerId,
				type
			});
		},
		sendReferralInvite() {
			const isInvalidPhone = !/^\d{10}$/g.test(this.phoneNo);
			// console.log("isInvalidPhone: ", isInvalidPhone);

			if (isInvalidPhone) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Please enter valid 10 digit phone number!"
				});
				return;
			}
			if (!this.sendInviteLoading) {
				this.sendInviteLoading = true;
				this.$store
					.dispatch(SEND_INVITE.dispatch, {
						referrerId: this.retailerId,
						phoneNo: parseInt(this.phoneNo, 10),
						countryAreaCode: 91
					})
					.then(() => {
						this.sendInviteLoading = false;
					})
					.catch(err => {
						console.error(err);
						this.phoneNo = null;
						this.sendInviteLoading = false;
					});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.dashed {
	border: 3px dashed #6da9e4;
	padding: 12px;
}
</style>
